exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7d3ae36e] .el-upload-dragger{height:130px!important;width:440px!important}[data-v-7d3ae36e] .el-upload-dragger .el-icon-upload{margin:18px 0 16px}.two-row[data-v-7d3ae36e]  .el-form-item__content{margin-right:0;width:440px;display:-webkit-box;display:-ms-flexbox;display:flex}.two-row[data-v-7d3ae36e]  .el-form-item__content .el-input-number{width:150px;margin-right:10px}.two-row[data-v-7d3ae36e]  .el-form-item__content .el-select{-webkit-box-flex:1;-ms-flex:1;flex:1}.two-row[data-v-7d3ae36e]  .el-form-item__content .el-select .el-input{width:100%}", ""]);

// exports
